import { Button } from '@/components/atoms';
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
	isRetire: boolean;
	isUndo: boolean;
	teamName: string;
	side: 'away' | 'home';
	gameNumber: number;
	onCancel: () => void;
	onConfirm: () => void;
}

export const ForfeitAndRetireModalContent = ({ isRetire, teamName, side, gameNumber, onCancel, onConfirm, isUndo }: Props) => {
	return (
		<div className="flex flex-col gap-6">
			<div className="relative w-full">
				<p className="text-black text-2xl font-medium">
					Confirm {isUndo ? 'undo ' : ''}
					{isRetire ? 'retire' : 'forfeit'}
				</p>
				<FontAwesomeIcon
					icon={faClose}
					className="cursor-pointer text-xl font-normal absolute right-0 top-1/2 -translate-y-1/2"
					onClick={onCancel}
				/>
			</div>
			<p className="text-orange-500 font-semibold text-lg">
				{teamName} - {side === 'away' ? 'Away' : 'Home'}
			</p>
			<p className="text-gray-900 font-semibold text-sm">
				{!isUndo
					? `Please confirm that you are ${isRetire ? 'retiring' : 'forfeiting'} Game ${gameNumber}`
					: `Please confirm that you are undoing the ${isRetire ? 'retirement' : 'forfeit'} of Game ${gameNumber}`}
			</p>
			<div className="flex gap-4 w-full justify-end">
				<Button
					className={`h-10 w-[7.5rem] border border-solid border-gray-300 bg-white text-sm font-semibold leading-5 !text-black hover:bg-gray-100`}
					onClick={onCancel}
				>
					Close
				</Button>
				<Button
					type="submit"
					onClick={onConfirm}
					className={`h-10 w-[7.5rem] bg-orange-500 text-sm font-semibold leading-5 hover:bg-orange-700 disabled:opacity-50 disabled:cursor-not-allowed text-white`}
				>
					Save
				</Button>
			</div>
		</div>
	);
};
